<div ngbDropdown placement="bottom" autoClose="outside" class="kt-header__topbar-item" #notificationMenu="ngbDropdown">
		<div ngbDropdownToggle class="kt-header__topbar-wrapper">
			<span class="kt-header__topbar-icon"
				[ngClass]="{'kt-pulse kt-pulse--brand': newNotificationCount, 'kt-pulse--light' : pulseLight, 'kt-header__topbar-icon--success' : iconType === 'success'	}">
				<i *ngIf="!useSVG" [ngClass]="icon"></i>
				<div [matBadge]="newNotificationCount? newNotificationCount : null">
					<span *ngIf="useSVG" class="kt-svg-icon"					
					[ngClass]="{'kt-svg-icon--success' : iconType === 'success', 'notification-available': newNotificationCount, 'no-notification-available': !newNotificationCount}" 
					[inlineSVG]="icon">
					</span>
					<i class="flaticon2-bell" style="font-size: 1.7rem;"></i>
				</div>
				<span class="kt-pulse__ring" [hidden]="!newNotificationCount"></span>
			</span>
			<span class="kt-badge kt-badge--dot kt-badge--notify kt-badge--sm kt-badge--brand" [hidden]="!dot"></span>
			
			<!-- <span class="kt-header__topbar-icon kt-pulse kt-pulse--brand">
				<span class="kt-pulse__ring" [hidden]="!newNotificationCount"></span>
				<i [ngClass]="icon"></i>
			</span> -->
		</div>
	
		<div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
			<form>
				<!--begin: Head -->
				<div class="kt-head kt-head--skin-{{skin}} kt-head--fit-x kt-head--fit-b" [ngStyle]="{'background-image': backGroundStyle() }">
					<h3 class="kt-head__title">
						{{'SYSTEM.NOTIFICATIONS.TITLE' | translate}}
					</h3>
					<div *ngIf="newNotificationCount > 0" style="width: 100%; text-align: center; margin-top: 1em;">
						<div class="btn btn-{{ type }} btn-sm btn-bold btn-font-md">
							{{'SYSTEM.NOTIFICATIONS.NEW_NOTIFICATIONS' | translate | stringFormat: newNotificationCount}}
						</div>
					</div>
					<ul ktTabClickEvent class="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-{{ type }} kt-notification-item-padding-x" role="tablist">
						<li class="nav-item">
							<a
								(click)="tab.select('tab-id-1')"
								class="nav-link active show"
								data-toggle="tab" href="javascript:;"
								role="tab" aria-selected="true">
								{{'SYSTEM.NOTIFICATIONS.ALERTS' | translate}}
							</a>
						</li>
					</ul>
				</div>
				<!--end: Head -->
	
				<ul ngbNav #tab="ngbNav">
					<li ngbNavItem="tab-id-1" id="tab-id-1">
						<ng-template ngbNavContent>
							<div [perfectScrollbar]="{wheelPropagation: false}" [ngStyle]="{'max-height': '40vh', 'position': 'relative', 'overflow-y': 'auto'}" class="kt-notification kt-margin-t-10 kt-margin-b-10">
								<a 
									*ngFor="let item of _notifications$ | async"
									href="javascript:;"
									(click)="redirectToScreen(item); notificationMenu.close();"
									class="kt-notification__item">
									<div class="kt-notification__item-icon">
										<i 
											*ngIf="!item.isRead"
											[matTooltip]="'SYSTEM.NOTIFICATIONS.TOOLTIP.MARK_UNREAD' | translate" 
											class="flaticon2-mail kt-font-success md-24"></i>
										<i 
											*ngIf="item.isRead"
											[matTooltip]="'SYSTEM.NOTIFICATIONS.TOOLTIP.MARK_READ' | translate"
											class="flaticon2-drafts kt-font-success md-24"></i>
									</div>
									<div class="kt-notification__item-details">
										<div 
											class="kt-notification__item-title"
											[innerHtml]="item.message">
										</div>
										<div class="kt-notification__item-time">
											{{ item.createDate | sentDate }}
										</div>
									</div>
								</a>
								<div
									*ngIf="(_notifications$ | async).length == 0"
									class="kt-notification__item">
									<div class="kt-notification__item-icon">
										<i class="flaticon2-exclamation kt-font-success"></i>
									</div>
									<div class="kt-notification__item-details">
										<div class="kt-notification__item-title">
											{{ 'SYSTEM.NOTIFICATIONS.NO_NOTIFICATION' | translate }}
										</div>
									</div>
								</div>
								<div class="ps__rail-x" style="left: 0px; bottom: 0px;">
									<div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
								</div>
								<div class="ps__rail-y" style="top: 0px; right: 0px;">
									<div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
								</div>
							</div>
						</ng-template>
					</li>
				</ul>

				<div [ngbNavOutlet]="tab"></div>
			</form>
		</div>
	</div>
